<template>
  <div class="ck-container">
    <el-row class="tcf-row">
      <el-col  class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="订单类型">
              <el-select v-model="searchForm.orderType" style="width: 120px" @keyup.enter.native="Search" filterable clearable>
                <el-option-group label="">
                  <el-option label="正单" :value="0" />
                  <el-option label="补单" :value="5" />
                </el-option-group>
                <el-option-group label="补单类型">
                  <el-option label="客改单" :value="1" />
                  <el-option label="增补单" :value="2" />
                  <el-option label="色板单" :value="3" />
                  <el-option label="售后单" :value="4" />
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="搜索关键字">
              <el-input v-model="searchForm.search" placeholder="关键字搜索" @keyup.enter.native="Search"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="Search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-copy-document" @click="Pjck">配件出库</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-document" @click="Ckjl">出库记录</el-button>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-printer" :loading="exportLoading" plain @click="exportExcel">导出Excel</el-button>
            </el-form-item>
          </el-form>
          <div class="card-content">
            <el-row>
              <el-col :span="24" v-loading="loading">
                <el-table
                  :data="tableData"
                  stripe
                  :row-style="{cursor: 'pointer'}"
                  @row-click="openDetails"
                  style="width: 100%">
                  <el-table-column
                    label="订单号"
                    width="120"
                    fixed
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.order_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="生产单号"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{scope.row.product_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="详细地址"
                    min-width="160"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.address}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="经销商"
                    width="120"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span :style="scope.row.all_name && scope.row.all_name.indexOf('VIP') > -1 ? 'font-weight: bold; color: #389e0d; font-style: italic;' : ''">
                        {{ scope.row.all_name }}
                      </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="订单类型"
                    width="110"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span v-if="scope.row.mark===0">正单</span>
                      <span v-if="scope.row.mark===1">客改单</span>
                      <span v-if="scope.row.mark===2">增补单</span>
                      <span v-if="scope.row.mark===3">色板单</span>
                      <span v-if="scope.row.mark===4">售后单</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="品牌"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.brand_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请出库时间"
                    width="170"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.out_apply_time}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="申请人"
                    fixed="right"
                    width="130"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span>{{scope.row.apply_name}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="包装数量"
                    width="130"
                    fixed="right"
                    align="center"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#f56c6c">{{scope.row.apply_num}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    width="120"
                    fixed="right"
                    align="center"
                    label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" icon="el-icon-finished" @click.stop="out(scope.row)">立即出库</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <el-pagination
                  v-if="total>0"
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total">
                </el-pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-dialog
      :title="editPackTitle"
      :visible.sync="editPackVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <el-form size="small" ref="editPackForm" :inline="true" :model="editPackForm" label-width="60px">
        <el-form-item label="标签号" prop="packnum">
          <el-input v-model="editPackForm.packnum" @keyup.enter="checkPack" ref="packnum" style="width: 300px" placeholder="请输入包标签号或扫描包装二维码" maxlength="14" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="checkPack" icon="el-icon-document-checked">核对</el-button>
        </el-form-item>
        <div style="font-size: 12px;color:#99a9bf;padding-left: 20px">
          <i class="el-icon-warning-outline"></i> 温馨提示：如果使用扫描器扫描没有反应，请<el-button @click="calibration" style="font-size: 12px" type="text">点击这里</el-button>！
        </div>
      </el-form>
      <div style="padding-bottom: 20px" v-loading="packloading">
        <el-table
          ref="multipleTable"
          :key="packTableKey"
          :data="packTableData"
          min-height="400"
          @selection-change="handleSelectionChange"
          size="small">
          <el-table-column fixed label="核对状态" align="center" width="100">
            <template slot-scope="props">
              <span v-if="props.row.is_select===0" style="color:#F56C6C"><i class="el-icon-error"></i> 等待核对</span>
              <span v-if="props.row.is_select===1" style="color:#67C23A"><i class="el-icon-success"></i> 核对成功</span>
            </template>
          </el-table-column>
          <el-table-column prop="package_num" fixed align="center" label="包标签号" show-overflow-tooltip min-width="130"></el-table-column>
          <el-table-column prop="xuhao" align="center" label="包号" show-overflow-tooltip width="80"></el-table-column>
          <el-table-column prop="total_unit" align="center" label="部件数量" show-overflow-tooltip width="80"></el-table-column>
          <el-table-column prop="time" align="center" label="申请时间" show-overflow-tooltip width="150"></el-table-column>
<!--          <el-table-column align="center" fixed="right" label="部件详细" show-overflow-tooltip width="100">-->
<!--            <template slot-scope="props">-->
<!--              <el-popover-->
<!--                placement="right"-->
<!--                width="500"-->
<!--                trigger="click">-->
<!--                <el-table-->
<!--                  :data="props.row.materialdataList"-->
<!--                  size="mini"-->
<!--                  style="width: 100%">-->
<!--                  <el-table-column prop="barCode" fixed label="条码" show-overflow-tooltip width="130"></el-table-column>-->
<!--                  <el-table-column prop="xuhao" fixed label="序号" show-overflow-tooltip width="70"></el-table-column>-->
<!--                  <el-table-column prop="area" label="区域" show-overflow-tooltip width="100"></el-table-column>-->
<!--                  <el-table-column prop="type" label="分类" show-overflow-tooltip width="80"></el-table-column>-->
<!--                  <el-table-column prop="name" label="名称" show-overflow-tooltip width="130"></el-table-column>-->
<!--                  <el-table-column prop="material" label="基材" show-overflow-tooltip width="80"></el-table-column>-->
<!--                  <el-table-column label="规格" show-overflow-tooltip width="140">-->
<!--                    <template slot-scope="scope">-->
<!--                      <span v-if="scope.row.high!=null&&scope.row.high!=''">{{scope.row.high}}</span>-->
<!--                      <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>-->
<!--                      <span v-if="scope.row.width!=null&&scope.row.width!=''">{{scope.row.width}}</span>-->
<!--                      <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>-->
<!--                      <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{scope.row.ply}}</span>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
<!--                  <el-table-column prop="color" label="颜色" show-overflow-tooltip min-width="130"></el-table-column>-->
<!--                </el-table>-->
<!--                <el-button slot="reference" icon="el-icon-link" size="mini">部件</el-button>-->
<!--              </el-popover>-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column
            type="selection"
            width="50">
          </el-table-column>
        </el-table>
      </div>
      <div class="tcf-panel">
        <p class="tcf-panel-header">
          <span><i class="el-icon-box"></i> 配件出库</span>
        </p>
        <el-button @click="addAccess" icon="el-icon-plus" size="small" style="position: absolute;right: 15px;top:4px;">添加配件</el-button>
        <div class="tcf-panel-body">
          <el-table
            :data="accessData"
            size="small"
            :show-header="false"
            style="width: 100%">
            <el-table-column
              width="120"
              fixed="left"
              align="center"
              label="配件明细">
              <template slot-scope="scope">
                <el-popover
                  placement="right"
                  width="370"
                  trigger="click">
                  <el-table
                    :data="scope.row.detail"
                    size="mini"
                    style="width: 100%">
                    <el-table-column prop="xuhao" show-overflow-tooltip width="80" label="序号"></el-table-column>
                    <el-table-column prop="name" width="120" show-overflow-tooltip label="名称"></el-table-column>
                    <el-table-column prop="num" show-overflow-tooltip width="80" label="数量"></el-table-column>
                    <el-table-column prop="unit" show-overflow-tooltip width="60" label="单位"></el-table-column>
                  </el-table>
                  <el-button type="text" size="mini" slot="reference" icon="el-icon-copy-document">配件明细</el-button>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column label="配件包号" show-overflow-tooltip width="220">
              <template slot-scope="scope">
                <span style="color:#9aaabf;">配件包号：</span>
                <span>{{scope.row.packnum}}</span>
              </template>
            </el-table-column>
            <el-table-column label="配件数量" show-overflow-tooltip min-width="80">
              <template slot-scope="scope">
                <span style="color:#9aaabf;">配件数量：</span>
                <span>{{scope.row.num}}</span>
              </template>
            </el-table-column>
            <el-table-column
              width="120"
              fixed="right"
              align="center"
              label="操作">
              <template slot-scope="scope">
                <el-button size="mini" @click="delAccess(scope.row)" icon="el-icon-delete">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <el-form size="small" ref="editPackForm" :model="editPackForm" :rules="editPackRules" label-width="60px">
        <el-form-item label="电话" prop="tel">
          <el-input v-model="editPackForm.tel" style="width: 200px" maxlength="11" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="editPackForm.address" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="editPackForm.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="subPackOut" :loading="fullscreenLoading" icon="el-icon-finished">立即出库</el-button>
        <el-button size="small" :loading="printLoading" icon="el-icon-printer" @click="printFhqd">打印发货清单</el-button>
        <el-button size="small" @click="editPackVisible=false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加出库配件"
      :visible.sync="editAccessVisible"
      width="50%"
      :destroy-on-close="true"
      :lock-scroll="true"
      :append-to-body="true">
      <div>
        <el-form :inline="true" size="small" :model="searchAccessForm">
          <el-form-item label="搜索关键字">
            <el-input v-model="searchAccessForm.search"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="addAccess" icon="el-icon-search">搜索</el-button>
            <el-button @click="checkAccessChange" icon="el-icon-check" type="primary" >确认选择</el-button>
          </el-form-item>
        </el-form>
        <div style="height: 490px;width: 100%" v-loading="materialloading">
          <pl-table
            :key="tableKey"
            height="490px"
            :datas="materialTableData"
            :data="materialTableData"
            use-virtual
            :pagination-show="false"
            @selection-change="handleAccessSelectionChange"
            size="small"
            :row-height="45">
            <pl-table-column type="selection" :selectable='checkboxInfoT' align="center" width="50"></pl-table-column>
            <pl-table-column prop="xuhao" :resizable="false" align="center" show-overflow-tooltip width="80" label="序号"></pl-table-column>
            <pl-table-column prop="area" label="区域" width="100" show-overflow-tooltip :resizable="false"></pl-table-column>
<!--            <pl-table-column prop="type" :resizable="false" align="center" show-overflow-tooltip width="90" label="分类"></pl-table-column>-->
            <pl-table-column prop="name" :resizable="false" width="120" show-overflow-tooltip align="center" label="名称"></pl-table-column>
            <pl-table-column prop="material" :resizable="false" align="center" show-overflow-tooltip width="90" label="基材"></pl-table-column>
            <pl-table-column label="规格" width="120" show-overflow-tooltip :resizable="false" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.high!=null&&scope.row.high!=''">{{scope.row.high}}</span>
                <span v-if="scope.row.high!=null&&scope.row.high!=''">×</span>
                <span v-if="scope.row.width!=null&&scope.row.width!=''">{{scope.row.width}}</span>
                <span v-if="scope.row.width!=null&&scope.row.width!=''">×</span>
                <span v-if="scope.row.ply!=null&&scope.row.ply!=''">{{scope.row.ply}}</span>
              </template>
            </pl-table-column>
            <pl-table-column prop="num" :resizable="false" align="center" show-overflow-tooltip width="80" label="数量"></pl-table-column>
            <pl-table-column prop="unit" :resizable="false" align="center" show-overflow-tooltip width="60" label="单位"></pl-table-column>
            <pl-table-column prop="color" width="120" :resizable="false" show-overflow-tooltip label="颜色" align="center"></pl-table-column>
            <pl-table-column prop="remark" min-width="100" :resizable="false" show-overflow-tooltip label="备注" align="center"></pl-table-column>
            <pl-table-column label="出库状态" fixed="right" :resizable="false" width="90" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :disable-transitions="true" v-if="scope.row.omark===1">已出库</el-tag>
                <el-tag size="mini" :disable-transitions="true" type="danger" v-if="scope.row.omark===0">未出库</el-tag>
              </template>
            </pl-table-column>
          </pl-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { getLodop } from '@/common/Lodop/LodopFuncs'
import {
  getOutStockList,
  getOutApplyDetail,
  outStock,
  exportOutDepotList,
  getErpOrderAccessoriesList, printShippingList
} from '@/api/erp'
import qs from 'qs'

export default {
  name: 'ck',
  computed: {
    user: getUser
  },
  data() {
    return {
      exportLoading: false,
      fullscreenLoading: false,
      searchForm: {
        search: '',
        orderType: null
      },
      searchAccessForm: {
        search: ''
      },
      loading: false,
      tableKey: '',
      printLoading: false,
      materialloading: false,
      materialTableData: [],
      tableData: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      editPackTitle: '',
      editPackVisible: false,
      editAccessVisible: false,
      packTableData: [],
      packloading: false,
      editPackForm: {
        orderid: '',
        applyid: '',
        packnum: '',
        tel: '',
        address: '',
        remark: ''
      },
      editPackRules: {
        tel: [{ required: true, message: '请输入联系电话', trigger: 'blur' }],
        address: [{ required: true, message: '请输入送货地址', trigger: 'blur' }]
      },
      packTableKey: '',
      ischeck: false,
      multipleSelection: [],
      accessData: [],
      multipleAccessSelection: []
    }
  },
  created() {
    this.getData()
    let keycode = ''
    let lastTime = null
    let nextTime = null
    let lastCode = null
    let nextCode = null
    const _this = this
    setTimeout(document.onkeydown = function(e) {
      if (window.event) {
        nextCode = e.keyCode // IE
      } else if (e.which) {
        nextCode = e.which // Netscape/Firefox/Opera
      }
      if ((nextCode >= 48 && nextCode <= 57) || (nextCode >= 96 && nextCode <= 105)) {
        // 数字键盘的键码值对应的字符有问题，所以手动调整键码值
        const codes = { '48': 48, '49': 49, '50': 50, '51': 51, '52': 52, '53': 53, '54': 54, '55': 55, '56': 56, '57': 57,
          '96': 48, '97': 49, '98': 50, '99': 51, '100': 52, '101': 53, '102': 54, '103': 55, '104': 56, '105': 57
        }
        nextCode = codes[nextCode]
        nextTime = new Date().getTime()
        if (lastCode === null && lastTime === null) {
          keycode = String.fromCharCode(nextCode)
        } else if (lastCode !== null && lastTime !== null && nextTime - lastTime <= 30) {
          keycode += String.fromCharCode(nextCode)
        } else {
          keycode = ''
          lastCode = null
          lastTime = null
        }
        lastCode = nextCode
        lastTime = nextTime
      } else if (nextCode === 13 && keycode !== '') {
        _this.editPackForm.packnum = keycode
        _this.checkPack()
        keycode = ''
        lastCode = null
        lastTime = null
      } else if (nextCode === 13) {
        _this.checkPack()
      } else if (keycode.length === 14) {
        _this.editPackForm.packnum = keycode
        _this.checkPack()
        keycode = ''
        lastCode = null
        lastTime = null
      }
    }, 100)
  },
  methods: {
    exportExcel() {
      if (!this.exportLoading) {
        this.exportLoading = true
        const data = {
          content: this.searchForm.search,
          groupid: this.user.dGroupid,
          userid: this.user.dUserid,
          role: this.user.role,
          orderType: this.searchForm.orderType,
          tableName: '出库'
        }
        exportOutDepotList(data).then(response => {
          this.exportLoading = false
          const _this = this
          let xhr = new XMLHttpRequest()
          xhr.open('GET', response.data.dPath, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status === 200) {
              let blob = this.response
              let a = document.createElement('a')
              a.download = response.data.dName + '.' + response.data.dType
              a.href = window.URL.createObjectURL(blob)
              a.target = '_blank'
              a.click()
              const h = _this.$createElement
              _this.$msgbox({
                title: '下载提示',
                message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
                  h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                  h('a',
                    { attrs: {
                      href: window.URL.createObjectURL(blob),
                      target: '_blank',
                      download: `${response.data.dName}.${response.data.dType}`,
                      style: 'color: #409EFF;text-decoration:underline;'
                    }}, `点击这里`),
                  h('span', null, `重新下载。`)
                ]),
                showCancelButton: false,
                confirmButtonText: '关闭',
                beforeClose: (action, instance, done) => {
                  done()
                }
              }).then(action => {
              })
            }
          }
          xhr.send()
        }).catch(() => {
          this.exportLoading = false
        })
      }
    },
    printFhqd() {
      if (this.packTableData.length > 0 || this.accessData.length > 0) {
        if (!this.printLoading) {
          const LODOP = getLodop()
          if (LODOP !== null && LODOP !== undefined) {
            this.printLoading = true
            let packids = []
            for (let p of this.packTableData) {
              packids.push(p.package_id)
            }
            let mdids = []
            for (const a of this.accessData) {
              for (const d of a.detail) {
                mdids.push(d.mdid)
              }
            }
            const data = {
              orderid: this.editPackForm.orderid,
              packids: packids.join(','),
              mdids: mdids.join(',')
            }
            printShippingList(data).then(response => {
              LODOP.PRINT_INIT('出库清单打印')
              LODOP.SET_PRINT_PAGESIZE(1, 0, 0, 'A4')
              LODOP.SET_PRINT_MODE('PRINT_PAGE_PERCENT', 'Auto-Width')
              LODOP.ADD_PRINT_TABLE(30, '11mm', '100%', '100%', response.data)
              LODOP.SET_PRINT_STYLEA(0, 'HOrient', 3)
              LODOP.SET_PRINT_STYLEA(0, 'VOrient', 3)
              LODOP.SET_SHOW_MODE('LANDSCAPE_DEFROTATED', 1)
              LODOP.NewPageA()
              LODOP.SET_PRINT_STYLEA(0, 'HtmWaitMilSecs', 100)
              LODOP.PREVIEW()
              this.printLoading = false
            }).catch(() => {
              this.printLoading = false
            })
          }
        }
      } else {
        this.$message.error('无出库包装打印')
      }
    },
    Pjck() {
      this.$router.push({ path: '/work/pjck' })
    },
    Ckjl() {
      this.$router.push({ path: '/work/ckjl' })
    },
    delAccess(row) {
      this.accessData.splice(this.accessData.indexOf(row), 1)
    },
    checkboxInfoT(row, rowIndex) {
      if (row.omark === 1) {
        return false
      } else {
        return true
      }
    },
    checkAccessChange() {
      let _accessData = []
      for (const m of this.multipleAccessSelection) {
        if (m.omark === 0) {
          _accessData.push(m)
        }
      }
      if (_accessData.length <= 0) {
        this.$message.error('至少选择一个配件')
        return
      }
      this.$prompt('请自定义输入配件包号', '确认提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /\S/,
        inputErrorMessage: '配件包号不可为空'
      }).then(({ value }) => {
        this.accessData.push({ packnum: value, num: _accessData.length, detail: _accessData })
        this.editAccessVisible = false
      }).catch(() => {})
    },
    handleAccessSelectionChange(val) {
      this.multipleAccessSelection = val
    },
    addAccess() {
      if (!this.editAccessVisible) {
        this.editAccessVisible = true
        this.searchAccessForm.search = ''
        this.multipleAccessSelection = []
      }
      this.materialTableData = []
      this.materialloading = true
      const data = {
        orderid: this.editPackForm.orderid,
        content: this.searchAccessForm.search
      }
      getErpOrderAccessoriesList(data).then(response => {
        this.tableKey = new Date().getTime()
        let _data = response.data
        for (const d of _data) {
          if (d.omark === 0) {
            let omark = d.omark
            for (const a of this.accessData) {
              for (const de of a.detail) {
                if (d.mdid === de.mdid) {
                  omark = 1
                }
              }
            }
            d.omark = omark
          }
        }
        this.materialTableData = _data
        this.materialloading = false
      }).catch(() => {
        this.materialloading = false
      })
    },
    Search() {
      if (this.searchForm.search !== null && this.searchForm.search.trim() !== '') {
        this.currentPage = 1
        this.getData()
      } else {
        this.searchForm.search = ''
        this.getData()
      }
    },
    getData() {
      this.loading = true
      const data = {
        content: this.searchForm.search,
        page: this.currentPage,
        limit: this.pageSize,
        groupid: this.user.dGroupid,
        userid: this.user.dUserid,
        role: this.user.role,
        orderType: this.searchForm.orderType
      }
      getOutStockList(data).then(response => {
        this.loading = false
        this.tableData = response.data
        this.total = response.total
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getData()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    openDetails(row) {
      this.$router.push({
        path: '/work/order/' + row.order_id.substring(0, 36),
        query: {
          data: row.order_id.substring(37)
        }
      })
    },
    out(row) {
      this.editPackForm.applyid = row.apply_id
      this.editPackForm.orderid = row.order_id
      console.log(this.editPackForm.orderid)
      this.editPackForm.packnum = ''
      this.editPackTitle = row.product_num + ' 申请出库包装列表'
      this.editPackVisible = true
      this.accessData = []
      this.searchPack()
    },
    searchPack() {
      this.ischeck = false
      this.packTableData = []
      this.packloading = true
      const data = {
        applyId: this.editPackForm.applyid,
        isall: 1
      }
      getOutApplyDetail(data).then(response => {
        this.packTableKey = new Date().getTime()
        this.packTableData = response.data.packageInfoVos
        this.editPackForm.tel = response.data.custTel
        this.editPackForm.address = response.data.address
        this.editPackForm.remark = ''
        this.packloading = false
        this.$refs.packnum.focus()
      }).catch(() => {
        this.packloading = false
      })
    },
    calibration() {
      this.$message({
        message: '初始成功，可以开始扫描啦~',
        type: 'success'
      })
      this.editPackForm.packnum = ''
      this.$refs.packnum.focus()
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
      let oknum = 0
      for (let i = 0; i < this.packTableData.length; i++) {
        let ishave = false
        for (let ms of this.multipleSelection) {
          if (ms.package_num === this.packTableData[i].package_num) {
            this.packTableData[i].is_select = 1
            oknum++
            ishave = true
            break
          }
        }
        if (!ishave) {
          this.packTableData[i].is_select = 0
        }
      }
      if (oknum === this.packTableData.length) {
        this.ischeck = true
      } else {
        this.ischeck = false
      }
    },
    checkPack() {
      // let oknum = 0
      for (let i = 0; i < this.packTableData.length; i++) {
        if (this.packTableData[i].is_select === 0) {
          if (this.editPackForm.packnum === this.packTableData[i].package_num) {
            // this.packTableData[i].is_select = 1
            this.$refs.multipleTable.toggleRowSelection(this.packTableData[i])
            break
            // oknum++
          }
        } else {
          // oknum++
        }
      }
      // if (oknum === this.packTableData.length) {
      //   this.ischeck = true
      // }
      this.editPackForm.packnum = ''
      this.$refs.packnum.focus()
    },
    subPackOut() {
      this.$refs[`editPackForm`].validate((valid) => {
        if (valid) {
          if (!this.fullscreenLoading) {
            if (this.ischeck) {
              this.$confirm('此操作将出库此 ' + this.packTableData.length + ' 个包装, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
                this.fullscreenLoading = true
                let outAccess = []
                for (const a of this.accessData) {
                  let mdids = []
                  for (const d of a.detail) {
                    mdids.push(d.mdid)
                  }
                  outAccess.push({ packnum: a.packnum, num: a.num, mdids: mdids.join(',') })
                }
                const data = {
                  orderid: this.editPackForm.orderid,
                  userid: this.user.dUserid,
                  applyid: this.editPackForm.applyid,
                  address: this.editPackForm.address,
                  tel: this.editPackForm.tel,
                  remark: this.editPackForm.remark,
                  outAccess: qs.parse(outAccess)
                }
                outStock(data).then(response => {
                  this.fullscreenLoading = false
                  this.$message({
                    message: '出库成功',
                    type: 'success'
                  })
                  this.editPackVisible = false
                  this.getData()
                }).catch(() => {
                  this.fullscreenLoading = false
                })
              }).catch(() => {})
            } else {
              this.$message.error('请核对出库的所有包装信息')
              this.$refs.packnum.focus()
            }
          } else {
            this.$refs.packnum.focus()
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ck-container {
  .tcf-row{
    .card{
      .card-body{
        .card-title{
          .search-mode{
            width: 300px;
            position: relative;
            float: right;
            margin-top: -10px;
            .search-input{
              background-color: #F2F6FC;
              border:0;
              height: 40px;
              line-height: 40px;
              border-radius: 4px;
              color: #606266;
              padding: 0 40px 0 15px;
              -webkit-appearance: none;
              font-size: 12px;
              width: 100%;
              -webkit-box-sizing: border-box;
              box-sizing: border-box;
              outline: 0;
              &::-webkit-input-placeholder {
                color: #C0C4CC;
              }
              &::-ms-input-placeholder {
                color: #C0C4CC;
              }
            }
            .search-btn{
              position: absolute;
              right: 0;
              height: 40px;
              width: 40px;
              line-height: 40px;
              top: 0;
              border: 0;
              background: transparent;
              text-align: center;
              padding: 0;
            }
          }
        }
        .card-content{
          .group-filter{
            width: 100%;
            padding: 0 30px 0 0 ;
            margin: 0 ;
            position: relative;
            li{
              width: 100%;
              list-style: none;
              position: relative;
              padding-left: 20px;
              padding-top: 15px;
              padding-bottom: 15px;
              cursor: pointer;
              border-radius: 2px;
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              &.active{
                background: #f5f7fa;
                color:#409EFF;
              }
              &:hover{
                color:#409EFF;
              }
            }
          }
          .el-table::before{
            height: 0!important;
          }
          .el-pagination{
            margin-top: 20px;
          }
        }
      }
    }
  }
}
</style>
